// Mock data for Dental & Oral Center

// Default clinic ID for fallback
export const DEFAULT_CLINIC_ID = "sample-clinic";

// Clinics Map - keyed by URL-friendly clinic name
export const clinicsMap = {
  "sample-clinic": {
    id: "sample-clinic",
    name: "Dubai Smile Dental Center",
    phone: "+971 4 423 9000",
    email: "info@dubaismiledental.ae",
    address: {
      street: "Dubai Healthcare City, Building 27",
      area: "Dubai",
      poBox: "Jumeirah Beach Residence, JBR Walk",
      country: "UAE"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+97144239000",
    googleMapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.1827!2d55.31927!3d25.22631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDEzJzM0LjciTiA1NcKwMTknMDkuNCJF!5e0!3m2!1sen!2sae!4v1234567890",
    rating: 4.9,
    reviewCount: 250
  },
  "al-majd-dental": {
    id: "al-majd-dental",
    name: "Al Majd Dental Clinic",
    phone: "+968 9915 7979",
    email: "",
    address: {
      street: "Flat no.101, First Floor P.O. 415, Ghubrah street",
      area: "South Al Ghubrah",
      poBox: "Opposite to Sultan Qaboos Stadium",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "10:00am – 1:00pm, 4:00pm – 10:00pm"
    },
    whatsapp: "+96899157979",
    googleMapsUrl: "https://www.google.com/maps?cid=11484639611057614717",
    rating: 4.9,
    reviewCount: 491
  },
  "smile-s-charm": {
    id: "smile-s-charm",
    name: "Smile's Charm Dental Clinic",
    phone: "+968 9452 7172",
    email: "",
    address: {
      street: "Bait alghoubra building, 4th floor, flat 42",
      area: "Almarefa Street, next to Aster hospital",
      poBox: "Muscat 132",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "12:00pm – 8:00pm"
    },
    whatsapp: "+96894527172",
    googleMapsUrl: "https://www.google.com/maps?cid=11074019344747019970",
    rating: 4.9,
    reviewCount: 301
  },
  "al-eman-dental": {
    id: "al-eman-dental",
    name: "Al Eman Dental Clinic",
    phone: "+968 24 834113",
    email: "",
    address: {
      street: "HGQM+FX3",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 7:00pm"
    },
    whatsapp: "+96824834113",
    googleMapsUrl: "https://www.google.com/maps?cid=8419047862583719154",
    rating: 4.7,
    reviewCount: 13
  },
  "dento-surg-dental": {
    id: "dento-surg-dental",
    name: "Dento Surg Dental & Implant Center",
    phone: "+968 9222 4924",
    email: "",
    address: {
      street: "P floor, no. 78",
      area: "184 40 St, Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "4:00pm – 8:00pm"
    },
    whatsapp: "+96892224924",
    googleMapsUrl: "https://www.google.com/maps?cid=17849278980601405548",
    rating: 4.9,
    reviewCount: 312
  },
  "zahrat-muscat-dental": {
    id: "zahrat-muscat-dental",
    name: "Zahrat Muscat Dental Clinic",
    phone: "+968 9788 8716",
    email: "",
    address: {
      street: "18th November St",
      area: "Muscat 121",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96897888716",
    googleMapsUrl: "https://www.google.com/maps?cid=1550347295661711286",
    rating: 5.0,
    reviewCount: 110
  },
  "mazoon-dental-clinic": {
    id: "mazoon-dental-clinic",
    name: "Mazoon Dental Clinic",
    phone: "+968 7974 3202",
    email: "",
    address: {
      street: "542 Mazoon street Alkhodh Seeb",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 11:00pm"
    },
    whatsapp: "+96879743202",
    googleMapsUrl: "https://www.google.com/maps?cid=7008812547818691130",
    rating: 4.8,
    reviewCount: 106
  },
  "brush-dental-centre": {
    id: "brush-dental-centre",
    name: "Brush Dental Centre",
    phone: "+968 7847 4101",
    email: "",
    address: {
      street: "Al Gadheer St",
      area: "Muscat 112",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96878474101",
    googleMapsUrl: "https://www.google.com/maps?cid=7578070601135204581",
    rating: 4.9,
    reviewCount: 352
  },
  "asnan-lounge-dental": {
    id: "asnan-lounge-dental",
    name: "Asnan Lounge Dental Center",
    phone: "+968 9282 8220",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96892828220",
    googleMapsUrl: "https://www.google.com/maps?cid=2256828154316896082",
    rating: 4.8,
    reviewCount: 137
  },
  "al-abeer-dental": {
    id: "al-abeer-dental",
    name: "Al Abeer Dental and Orthodontic Clinic",
    phone: "+968 9212 3836",
    email: "",
    address: {
      street: "Al Barakat St",
      area: "Seeb 121",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96892123836",
    googleMapsUrl: "https://www.google.com/maps?cid=191141389117984823",
    rating: 4.9,
    reviewCount: 455
  },
  "dentology-dental-clinic": {
    id: "dentology-dental-clinic",
    name: "Dentology Dental Clinic",
    phone: "+968 9090 0626",
    email: "",
    address: {
      street: "4034, Al Ghubrah St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96890900626",
    googleMapsUrl: "https://www.google.com/maps?cid=11252864387086194220",
    rating: 5.0,
    reviewCount: 505
  },
  "doctor-station-drs": {
    id: "doctor-station-drs",
    name: "Doctor Station DrS Dental Clinic",
    phone: "+968 7172 7008",
    email: "",
    address: {
      street: "Al Maha St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 9:00pm"
    },
    whatsapp: "+96871727008",
    googleMapsUrl: "https://www.google.com/maps?cid=2562537610598684838",
    rating: 5.0,
    reviewCount: 149
  },
  "confidental-clinic": {
    id: "confidental-clinic",
    name: "Confidental Clinic",
    phone: "+968 9254 9007",
    email: "",
    address: {
      street: "Office #25-A, Alargan Towell, 1st Floor 2237 Way",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:30am – 8:30pm"
    },
    whatsapp: "+96892549007",
    googleMapsUrl: "https://www.google.com/maps?cid=11677318797656983810",
    rating: 4.9,
    reviewCount: 49
  },
  "child-dental-centre": {
    id: "child-dental-centre",
    name: "Child Dental Centre",
    phone: "+968 24 696622",
    email: "",
    address: {
      street: "3024 Way",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 8:30pm"
    },
    whatsapp: "+96824696622",
    googleMapsUrl: "https://www.google.com/maps?cid=16136412206916995550",
    rating: 4.9,
    reviewCount: 141
  },
  "oman-dental-clinic": {
    id: "oman-dental-clinic",
    name: "Oman Dental Clinic",
    phone: "+968 9461 7577",
    email: "",
    address: {
      street: "HGQM+CXM, Ruwi St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "9:00am – 5:00pm"
    },
    whatsapp: "+96894617577",
    googleMapsUrl: "https://www.google.com/maps?cid=13989041873799188337",
    rating: 5.0,
    reviewCount: 2
  },
  "korean-dental-center": {
    id: "korean-dental-center",
    name: "Korean Dental Center",
    phone: "+968 9282 2456",
    email: "",
    address: {
      street: "232 Al Maha St",
      area: "Muscat 136",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "10:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96892822456",
    googleMapsUrl: "https://www.google.com/maps?cid=4970596099977257420",
    rating: 4.4,
    reviewCount: 37
  },
  "great-care-dental": {
    id: "great-care-dental",
    name: "Great Care Dental Clinic",
    phone: "+968 9262 6351",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "9:00am – 8:00pm"
    },
    whatsapp: "+96892626351",
    googleMapsUrl: "https://www.google.com/maps?cid=2029051780835837490",
    rating: 4.7,
    reviewCount: 37
  },
  "lebanese-dental-clinic": {
    id: "lebanese-dental-clinic",
    name: "Lebanese Dental Clinic",
    phone: "+968 9670 0335",
    email: "",
    address: {
      street: "Lebanese Dental Clinic, 18th November St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96896700335",
    googleMapsUrl: "https://www.google.com/maps?cid=7180180139432876359",
    rating: 5.0,
    reviewCount: 75
  },
  "afnan-dental-clinic": {
    id: "afnan-dental-clinic",
    name: "Afnan Dental Clinic",
    phone: "+968 24 797303",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:30am – 8:30pm"
    },
    whatsapp: "+96824797303",
    googleMapsUrl: "https://www.google.com/maps?cid=10715458478879156473",
    rating: 4.6,
    reviewCount: 16
  },
  "modern-iraqi-clinics": {
    id: "modern-iraqi-clinics",
    name: "Modern Iraqi Clinics",
    phone: "+968 9596 7799",
    email: "",
    address: {
      street: "Al Ehsan Street",
      area: "Muscat / Al Amarat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96895967799",
    googleMapsUrl: "https://www.google.com/maps?cid=17327661567083371582",
    rating: 4.9,
    reviewCount: 187
  },
  "miswak-dental-clinic": {
    id: "miswak-dental-clinic",
    name: "Miswak Dental Clinic",
    phone: "+968 9785 4321",
    email: "",
    address: {
      street: "111 18th November St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:30am – 9:00pm"
    },
    whatsapp: "+96897854321",
    googleMapsUrl: "https://www.google.com/maps?cid=2124570147703304372",
    rating: 5.0,
    reviewCount: 26
  },
  "muscat-dental-design": {
    id: "muscat-dental-design",
    name: "Muscat Dental Design Center",
    phone: "+968 9293 6587",
    email: "",
    address: {
      street: "J63C+JQF",
      area: "Seeb",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96892936587",
    googleMapsUrl: "https://www.google.com/maps?cid=3815030558976235656",
    rating: 4.6,
    reviewCount: 158
  },
  "shirin-s-dental": {
    id: "shirin-s-dental",
    name: "Shirin's Dental Clinic",
    phone: "+968 9210 6684",
    email: "",
    address: {
      street: "Near Rawasco, Shanfari Building, Al Khuwair St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96892106684",
    googleMapsUrl: "https://www.google.com/maps?cid=1196304635367256232",
    rating: 4.8,
    reviewCount: 33
  },
  "dental-hub": {
    id: "dental-hub",
    name: "Dental Hub",
    phone: "+968 22 700542",
    email: "",
    address: {
      street: "Muna gardens St",
      area: "Muscat 130",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96822700542",
    googleMapsUrl: "https://www.google.com/maps?cid=11628347455788014885",
    rating: 4.9,
    reviewCount: 92
  },
  "sister-s-dental": {
    id: "sister-s-dental",
    name: "Sister's Dental Clinic",
    phone: "+968 24 605116",
    email: "",
    address: {
      street: "JF77+HP4",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96824605116",
    googleMapsUrl: "https://www.google.com/maps?cid=10813742311449956302",
    rating: 5.0,
    reviewCount: 7
  },
  "emarat-al-sharq": {
    id: "emarat-al-sharq",
    name: "Emarat Al Sharq Dental Clinic",
    phone: "+968 9330 7432",
    email: "",
    address: {
      street: "Al Burj St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96893307432",
    googleMapsUrl: "https://www.google.com/maps?cid=6163979035937290514",
    rating: 4.7,
    reviewCount: 26
  },
  "dentrust-dental-centre": {
    id: "dentrust-dental-centre",
    name: "DenTrust Dental Centre",
    phone: "+968 9808 0502",
    email: "",
    address: {
      street: "A Salam St",
      area: "Seeb 111",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96898080502",
    googleMapsUrl: "https://www.google.com/maps?cid=6711969115608948507",
    rating: 4.9,
    reviewCount: 174
  },
  "imperial-dental-centre": {
    id: "imperial-dental-centre",
    name: "Imperial Dental Centre Muscat",
    phone: "+968 24 797406",
    email: "",
    address: {
      street: "JG3X+XPW, JG3X+XGF way 3233",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96824797406",
    googleMapsUrl: "https://www.google.com/maps?cid=11586756746171519592",
    rating: 4.7,
    reviewCount: 30
  },
  "euro-arabian-specialist": {
    id: "euro-arabian-specialist",
    name: "Euro Arabian Specialist Dental Center",
    phone: "+968 9925 8100",
    email: "",
    address: {
      street: "villa 1367, way 1925",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Wednesday",
      time: "9:00am – 1:30pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96899258100",
    googleMapsUrl: "https://www.google.com/maps?cid=2071331632691200234",
    rating: 3.4,
    reviewCount: 26
  },
  "muscat-dental-center": {
    id: "muscat-dental-center",
    name: "Muscat Dental Center",
    phone: "+968 9138 8029",
    email: "",
    address: {
      street: "unit 201, Building 397-1, 18th November St",
      area: "Muscat 130",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "1:00pm – 9:00pm"
    },
    whatsapp: "+96891388029",
    googleMapsUrl: "https://www.google.com/maps?cid=8915585427906314713",
    rating: 4.1,
    reviewCount: 28
  },
  "zain-dental-center": {
    id: "zain-dental-center",
    name: "Zain Dental Center",
    phone: "+968 24 600009",
    email: "",
    address: {
      street: "3505st flat 13",
      area: "Muscat 133",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96824600009",
    googleMapsUrl: "https://www.google.com/maps?cid=14972791453607032219",
    rating: 4.7,
    reviewCount: 38
  },
  "afnan-dental-clinic-1": {
    id: "afnan-dental-clinic-1",
    name: "Afnan Dental Clinic - Bareeq Al Shatti",
    phone: "+968 9595 1199",
    email: "",
    address: {
      street: "Bareeq al Shatti",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 7:30pm"
    },
    whatsapp: "+96895951199",
    googleMapsUrl: "https://www.google.com/maps?cid=16755555594164237123",
    rating: 4.7,
    reviewCount: 15
  },
  "al-ghubrah-dental": {
    id: "al-ghubrah-dental",
    name: "Al Ghubrah Dental Speciality Centre",
    phone: "+968 24 497708",
    email: "",
    address: {
      street: "Al Marafah Street Way, 238 building no. 90",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96824497708",
    googleMapsUrl: "https://www.google.com/maps?cid=7618002853517471557",
    rating: 4.7,
    reviewCount: 10
  },
  "arak-medical-clinics": {
    id: "arak-medical-clinics",
    name: "Arak Medical Clinics - Bausher Branch",
    phone: "+968 9074 2244",
    email: "",
    address: {
      street: "Street 22",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "7:00am – 10:00pm"
    },
    whatsapp: "+96890742244",
    googleMapsUrl: "https://www.google.com/maps?cid=17688505063938561437",
    rating: 4.1,
    reviewCount: 731
  },
  "happy-world-dental": {
    id: "happy-world-dental",
    name: "Happy World Dental Clinic - Azaiba",
    phone: "+968 7900 2875",
    email: "",
    address: {
      street: "Beside Al Mira hypermarket and Azaiba Mall",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 3:00pm"
    },
    whatsapp: "+96879002875",
    googleMapsUrl: "https://www.google.com/maps?cid=16730953976762983177",
    rating: 4.4,
    reviewCount: 41
  },
  "prodent-dental-clinic": {
    id: "prodent-dental-clinic",
    name: "ProDent Dental Clinic",
    phone: "+968 9712 4197",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 8:00pm"
    },
    whatsapp: "+96897124197",
    googleMapsUrl: "https://www.google.com/maps?cid=586406209063116940",
    rating: 4.6,
    reviewCount: 24
  },
  "sun-dental-centre": {
    id: "sun-dental-centre",
    name: "Sun Dental Centre Mawaleh",
    phone: "+968 9228 1356",
    email: "",
    address: {
      street: "Near Carrefour, City Centre, first Floor, NBO Building",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96892281356",
    googleMapsUrl: "https://www.google.com/maps?cid=13424740214408842708",
    rating: 4.7,
    reviewCount: 30
  },
  "purecare-dental-center": {
    id: "purecare-dental-center",
    name: "Purecare Dental Center",
    phone: "+968 9696 0396",
    email: "",
    address: {
      street: "J4XC+MCQ",
      area: "Seeb",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:30am – 9:30pm"
    },
    whatsapp: "+96896960396",
    googleMapsUrl: "https://www.google.com/maps?cid=7683504114647269069",
    rating: 4.8,
    reviewCount: 137
  },
  "assalam-dental-clinic": {
    id: "assalam-dental-clinic",
    name: "Assalam Dental Clinic",
    phone: "+968 9905 2633",
    email: "",
    address: {
      street: "Al Mazoon street, Al Mawaleh",
      area: "Muscat 121",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96899052633",
    googleMapsUrl: "https://www.google.com/maps?cid=14235248982804976243",
    rating: 4.8,
    reviewCount: 35
  },
  "malak-dental-centre": {
    id: "malak-dental-centre",
    name: "Malak Dental Centre",
    phone: "+968 24 490779",
    email: "",
    address: {
      street: "J92H+2QF",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 8:00pm"
    },
    whatsapp: "+96824490779",
    googleMapsUrl: "https://www.google.com/maps?cid=12413551707650945529",
    rating: 3.9,
    reviewCount: 16
  },
  "brazilian-medical-center": {
    id: "brazilian-medical-center",
    name: "Brazilian Medical Center",
    phone: "+968 9750 1313",
    email: "",
    address: {
      street: "Al Maha St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 8:00pm"
    },
    whatsapp: "+96897501313",
    googleMapsUrl: "https://www.google.com/maps?cid=18327406921236935399",
    rating: 4.1,
    reviewCount: 42
  },
  "dental-clinic": {
    id: "dental-clinic",
    name: "Hakeem Dental Center",
    phone: "+968 9333 1331",
    email: "",
    address: {
      street: "Opposite Health Center, Al Sad Street",
      area: "As Sad St, 132",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:00am – 9:00pm"
    },
    whatsapp: "+96893331331",
    googleMapsUrl: "https://www.google.com/maps?cid=16156407434934043908",
    rating: 4.3,
    reviewCount: 55
  },
  "dar-al-shifa": {
    id: "dar-al-shifa",
    name: "Dar Al Shifa Muscat Specialized Polyclinic",
    phone: "+968 24 128182",
    email: "",
    address: {
      street: "Al Marafah St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96824128182",
    googleMapsUrl: "https://www.google.com/maps?cid=2211052990837257962",
    rating: 4.6,
    reviewCount: 28
  },
  "arabian": {
    id: "arabian",
    name: "Arabian Dental Center",
    phone: "+968 24 545733",
    email: "",
    address: {
      street: "Al Mauj St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 9:00pm"
    },
    whatsapp: "+96824545733",
    googleMapsUrl: "https://www.google.com/maps?cid=12727161853750680412",
    rating: 3.6,
    reviewCount: 20
  },
  "al-hakeem-medical": {
    id: "al-hakeem-medical",
    name: "Al Hakeem Medical Center - Dental",
    phone: "+968 9175 5657",
    email: "",
    address: {
      street: "Al Khuwair, between Zakher Mall and Radisson Blue Hotel",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 7:00pm"
    },
    whatsapp: "+96891755657",
    googleMapsUrl: "https://www.google.com/maps?cid=2338168757264101179",
    rating: 4.3,
    reviewCount: 20
  },
  "muscat-smile-dental": {
    id: "muscat-smile-dental",
    name: "Muscat Smile Dental Clinic",
    phone: "+968 9988 8465",
    email: "",
    address: {
      street: "Al Mazoon St",
      area: "Seeb",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96899888465",
    googleMapsUrl: "https://www.google.com/maps?cid=4635189909298599037",
    rating: 4.8,
    reviewCount: 22
  },
  "perio-clinic": {
    id: "perio-clinic",
    name: "Perio Clinic",
    phone: "+968 7117 0077",
    email: "",
    address: {
      street: "3117 Way",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Tuesday",
      time: "12:00pm – 9:00pm"
    },
    whatsapp: "+96871170077",
    googleMapsUrl: "https://www.google.com/maps?cid=15431364739743020112",
    rating: 4.7,
    reviewCount: 27
  },
  "quality-dentalorhtodontic-cent": {
    id: "quality-dentalorhtodontic-cent",
    name: "Quality Dental & Orthodontic Center",
    phone: "+968 7906 7343",
    email: "",
    address: {
      street: "J4Q8+MGQ",
      area: "Seeb",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 2:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96879067343",
    googleMapsUrl: "https://www.google.com/maps?cid=15832975410405075679",
    rating: 4.8,
    reviewCount: 57
  },
  "julia-dental-clinic": {
    id: "julia-dental-clinic",
    name: "Julia Dental Clinic",
    phone: "+968 9881 2740",
    email: "",
    address: {
      street: "Above OIFC Khedmah",
      area: "Barka 320",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:30am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96898812740",
    googleMapsUrl: "https://www.google.com/maps?cid=2609023393628991047",
    rating: 4.8,
    reviewCount: 56
  },
  "islam-dental-clinic": {
    id: "islam-dental-clinic",
    name: "Islam Dental Clinic",
    phone: "+968 9505 5172",
    email: "",
    address: {
      street: "Next to Safa Hypermarket, South Maabilah, above Safa Bakery",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "4:00pm – 9:00pm"
    },
    whatsapp: "+96895055172",
    googleMapsUrl: "https://www.google.com/maps?cid=214446558092770178",
    rating: 3.5,
    reviewCount: 24
  },
  "dental-clinic-1": {
    id: "dental-clinic-1",
    name: "Al Safwa Modern Medical Center",
    phone: "+968 9100 0391",
    email: "",
    address: {
      street: "Al Khoud Street 132 Seeb",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "9:00am – 10:00pm"
    },
    whatsapp: "+96891000391",
    googleMapsUrl: "https://www.google.com/maps?cid=15524411645537969605",
    rating: 4.2,
    reviewCount: 170
  },
  "um-salama-dental": {
    id: "um-salama-dental",
    name: "Um Salama Dental Clinic",
    phone: "+968 7976 1704",
    email: "",
    address: {
      street: "Ruwi St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 8:00pm"
    },
    whatsapp: "+96879761704",
    googleMapsUrl: "https://www.google.com/maps?cid=17944048212206207645",
    rating: 4.3,
    reviewCount: 16
  },
  "emc-skin-clinic": {
    id: "emc-skin-clinic",
    name: "EMC Skin Clinic Oman - Dermatology & Dentistry",
    phone: "+968 24 604540",
    email: "",
    address: {
      street: "Sultan Qaboos Street Qurum - Al Sarooj Plaza Mina Al Fahhal",
      area: "487",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:30am – 9:00pm"
    },
    whatsapp: "+96824604540",
    googleMapsUrl: "https://www.google.com/maps?cid=9453167141116036118",
    rating: 4.7,
    reviewCount: 1376
  },
  "denta-centre": {
    id: "denta-centre",
    name: "Denta Centre",
    phone: "+968 24 566395",
    email: "",
    address: {
      street: "JF7X+C7J",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "9:00am – 6:00pm"
    },
    whatsapp: "+96824566395",
    googleMapsUrl: "https://www.google.com/maps?cid=1871855993980113821",
    rating: 5.0,
    reviewCount: 4
  },
  "smile-care-dental": {
    id: "smile-care-dental",
    name: "Smile Care Dental Clinic - Bowsher Branch",
    phone: "+968 9755 8832",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Friday",
      time: "9:00am – 12:00pm, 4:00pm – 9:00pm"
    },
    whatsapp: "+96897558832",
    googleMapsUrl: "https://www.google.com/maps?cid=15286895598434402367",
    rating: 4.0,
    reviewCount: 21
  },
  "mr-laser-dental": {
    id: "mr-laser-dental",
    name: "Mr. Laser Dental Center",
    phone: "+968 7712 3477",
    email: "",
    address: {
      street: "Al Khoud 6, opposite Pizza Hut, Seeb - Al Khoud",
      area: "315",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 10:00pm"
    },
    whatsapp: "+96877123477",
    googleMapsUrl: "https://www.google.com/maps?cid=14488366383670365622",
    rating: 4.8,
    reviewCount: 53
  },
  "alpha-dent-dental": {
    id: "alpha-dent-dental",
    name: "Alpha Dent Dental Clinic",
    phone: "+968 9066 8777",
    email: "",
    address: {
      street: "91 A 18th Nov street, Al Ghubrah Ash Shamaliyyah",
      area: "121",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "12:00pm – 9:00pm"
    },
    whatsapp: "+96890668777",
    googleMapsUrl: "https://www.google.com/maps?cid=12305296047635222024",
    rating: 4.6,
    reviewCount: 10
  },
  "al-karama-star": {
    id: "al-karama-star",
    name: "Al Karama Star Dental Clinic",
    phone: "+968 9179 1044",
    email: "",
    address: {
      street: "HGXR+C33",
      area: "Muscat 112",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "8:00am – 6:00pm"
    },
    whatsapp: "+96891791044",
    googleMapsUrl: "https://www.google.com/maps?cid=10467261183601548617",
    rating: 5.0,
    reviewCount: 1
  },
  "fullcare-dental-clinic": {
    id: "fullcare-dental-clinic",
    name: "Fullcare Dental Clinic - Mubaela Branch",
    phone: "+968 9599 9435",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 2:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96895999435",
    googleMapsUrl: "https://www.google.com/maps?cid=180474786735013538",
    rating: 4.4,
    reviewCount: 13
  },
  "horizon-dental-clinic": {
    id: "horizon-dental-clinic",
    name: "Horizon Dental Clinic",
    phone: "+968 7987 8645",
    email: "",
    address: {
      street: "HGVV+9F2, Village",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Friday",
      time: "9:00am – 1:00pm, 4:00pm – 9:00pm"
    },
    whatsapp: "+96879878645",
    googleMapsUrl: "https://www.google.com/maps?cid=9264406892665824290",
    rating: 3.3,
    reviewCount: 22
  },
  "dr-vinay-shivagange": {
    id: "dr-vinay-shivagange",
    name: "Dr Vinay Shivagange - Specialist Micro-Endodontist",
    phone: "+968 9407 1985",
    email: "",
    address: {
      street: "Next to Bank Muscat Building, Mamoorah Royal Dental Center, Al Enaam Building, Al Mauj St",
      area: "128",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 7:00pm"
    },
    whatsapp: "+96894071985",
    googleMapsUrl: "https://www.google.com/maps?cid=8325174053162036148",
    rating: 4.9,
    reviewCount: 11
  },
  "dental-clinic-2": {
    id: "dental-clinic-2",
    name: "Sala Medical Complex",
    phone: "+968 24 485153",
    email: "",
    address: {
      street: "HCVG+PJ2, Al Khuwair St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "10:00am – 2:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96824485153",
    googleMapsUrl: "https://www.google.com/maps?cid=9021808186633912068",
    rating: 4.9,
    reviewCount: 36
  },
  "elite-clinic": {
    id: "elite-clinic",
    name: "Elite Clinic",
    phone: "+968 7936 4117",
    email: "",
    address: {
      street: "Muscat",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "11:00am – 7:00pm"
    },
    whatsapp: "+96879364117",
    googleMapsUrl: "https://www.google.com/maps?cid=2855515373235528583",
    rating: 3.9,
    reviewCount: 58
  },
  "juman-speciality-center": {
    id: "juman-speciality-center",
    name: "Juman Speciality Center",
    phone: "+968 9889 7988",
    email: "",
    address: {
      street: "18th November St",
      area: "Muscat",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Sunday – Thursday",
      time: "11:00am – 8:00pm"
    },
    whatsapp: "+96898897988",
    googleMapsUrl: "https://www.google.com/maps?cid=218456023371987118",
    rating: 4.8,
    reviewCount: 31
  },
  "gulf-premier-speciality": {
    id: "gulf-premier-speciality",
    name: "Gulf Premier Speciality Dental Centre",
    phone: "+968 26 884334",
    email: "",
    address: {
      street: "Barka",
      area: "Oman",
      poBox: "",
      country: "Sultanate of Oman"
    },
    hours: {
      weekdays: "Saturday – Thursday",
      time: "9:00am – 1:00pm, 5:00pm – 9:00pm"
    },
    whatsapp: "+96826884334",
    googleMapsUrl: "https://www.google.com/maps?cid=473196650779956302",
    rating: 4.2,
    reviewCount: 50
  }
};

// Helper function to get clinic by ID with fallback to default
export const getClinicById = (clinicId) => {
  if (clinicId && clinicsMap[clinicId]) {
    return clinicsMap[clinicId];
  }
  return clinicsMap[DEFAULT_CLINIC_ID];
};

// Legacy export for backward compatibility (uses default clinic)
export const clinicInfo = clinicsMap[DEFAULT_CLINIC_ID];

export const services = [
  {
    id: 1,
    title: "General Dentistry",
    icon: "Stethoscope",
    description: "Comprehensive dental care for your overall oral health and well-being",
    items: [
      "Dental Exams",
      "Cleaning",
      "Fillings",
      "Crown & Bridge work",
      "Root Canal treatments",
      "Wisdom Teeth procedures",
      "Gum treatment",
      "Emergency care"
    ],
    image: "https://images.unsplash.com/photo-1606811842243-af7e16970c1f"
  },
  {
    id: 2,
    title: "Cosmetic Dentistry",
    icon: "Sparkles",
    description: "Transform your smile with our meticulous cosmetic procedures",
    items: [
      "Veneers",
      "Professional teeth whitening",
      "Gum shaping",
      "Smile Evaluation Exam",
      "Clear Tooth Aligners"
    ],
    image: "https://images.unsplash.com/photo-1657470179447-0f5aa16daa91"
  },
  {
    id: 3,
    title: "Kids Dentistry",
    icon: "Baby",
    description: "Gentle dental care for children to build healthy oral habits",
    items: [
      "Dental Exams",
      "Cleaning",
      "Fluoride Treatment",
      "Space Maintainers",
      "Fillings"
    ],
    image: "https://images.pexels.com/photos/4269695/pexels-photo-4269695.jpeg"
  },
  {
    id: 4,
    title: "Speciality Services",
    icon: "Award",
    description: "Expert care for specialized dental needs",
    items: [
      "TMJ (Jaw Pain Disorders)",
      "Oral Cancer Screening",
      "Implant Restoration",
      "Clear Tooth Aligners"
    ],
    image: "https://images.pexels.com/photos/4270362/pexels-photo-4270362.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al-Balushi",
    text: "Flew across the world to let my wisdom teeth get removed by this clinic because I knew they were the best-in-the-business. Didn't have any regrets after!",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmed"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    text: "I hadn't been to a dentist in many years, but had agonizing pain in a broken tooth. The dentist was patient, informative, humorous and skilled, everything you need in a top class dentist. Really put me at ease.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah"
  },
  {
    id: 3,
    name: "Fatima Al-Rashdi",
    text: "The dentist is AWESOME! Has a great manner with kids and knows just the right things to say to make them feel at ease. I had the most ridiculous fear of going to the dentist, but now that is all in the past!",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Fatima"
  },
  {
    id: 4,
    name: "Mohammed Al-Harthi",
    text: "I would say this is the best dentist I've ever had. Has the ability to make you feel relaxed and to trust in the work that will be done on your teeth. I totally recommend this clinic.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Mohammed"
  },
  {
    id: 5,
    name: "Layla Al-Hinai",
    text: "Definitely the best dentist in Oman. My entire family and extended family love this clinic. Has the ability to put people at ease and each procedure seems quick and painless.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Layla"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What should I do if I have a dental emergency?",
    answer: "Contact the clinic immediately at +968 24 573892 for urgent assistance. We understand dental emergencies can be stressful and we're here to help you promptly during our office hours (Sunday-Thursday, 9:00am-6:30pm)."
  },
  {
    id: 2,
    question: "How can I book an appointment?",
    answer: "You can book an appointment in three convenient ways: Use our online appointment form on this website, call us directly at +968 24 573892, or send us a message via WhatsApp. We'll contact you to confirm your preferred time and date."
  },
  {
    id: 3,
    question: "Do you accept walk-in patients?",
    answer: "Walk-ins are welcome based on availability, but appointments are highly recommended to ensure you receive prompt care at your preferred time. Call us ahead to check availability."
  },
  {
    id: 4,
    question: "What services do you offer for children?",
    answer: "We provide gentle, child-friendly dental care including dental exams, cleaning, fluoride treatments, space maintainers, and fillings. Our dentists have extensive experience working with children and creating a comfortable, anxiety-free environment."
  },
  {
    id: 5,
    question: "Do you offer cosmetic dentistry services?",
    answer: "Yes! Dr. Dabbous has transformed smiles for many years. Our cosmetic dentistry services include veneers, professional teeth whitening, gum shaping, smile evaluation exams, and clear tooth aligners. We create beautiful smiles by enhancing both aesthetics and function."
  },
  {
    id: 6,
    question: "What are your payment options?",
    answer: "We accept various payment methods including cash, credit cards, and insurance. Please contact us at +968 24 573892 to discuss specific payment options and insurance coverage for your treatment."
  }
];

export const beforeAfterGallery = [
  {
    id: 1,
    title: "Teeth Whitening",
    description: "Professional whitening treatment",
    category: "Cosmetic"
  },
  {
    id: 2,
    title: "Veneers",
    description: "Complete smile makeover with veneers",
    category: "Cosmetic"
  },
  {
    id: 3,
    title: "Dental Implants",
    description: "Implant restoration for missing teeth",
    category: "Specialty"
  },
  {
    id: 4,
    title: "Orthodontics",
    description: "Clear aligners transformation",
    category: "Cosmetic"
  }
];

// Mock appointment submission with toast notification
export const submitAppointment = (appointmentData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock appointment submitted:", appointmentData);
      const result = {
        success: true,
        message: "Thank you! We will contact you shortly to confirm your appointment.",
        appointmentId: `APT${Date.now()}`,
        showToast: true // Flag to trigger toast notification
      };
      resolve(result);
    }, 1000);
  });
};
